/**
 * 响应式布局配置
 */
export const PC_H5_CFG = {
    MIN_PC_INNER_WIDTH: 1000, // 最小pc端宽度
    MAX_PHONE_INNER_WIDTH: 768 // 最大移动端宽度
};
